// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:0)and (max-width:767px){.science-our-labs__info-container{overflow:scroll}}@media(min-width:0)and (max-width:767px){.science-our-labs__info-card{box-shadow:4px 4px 10px rgba(0,0,0,.1);flex-basis:80%;flex-shrink:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
